import * as React from 'react';
import {connect} from "react-redux";
import classnames from "classnames";
import PropTypes from "prop-types";
import {injectIntl} from "react-intl";

function SliderSummary(props) {
	const {question, detail, min, max} = props
	const value1 = detail.value1;
	const value2 = detail.value2;
	const defaultValue = question.defaultValue;

	const countLeftPosition = (value, isMax) => {
		if (question.range) {
			if (isMax) {
				if (_.isNull(value)) {
					value = max;
				}
			} else {
				if (_.isNull(value)) {
					value = min;
				}
			}
		} else if (_.isNull(value)) {
			value = defaultValue;
		}

		value = Number(value);
		if (value <= 0) {
			value = 0;
		}

		let displayMax = max;
		let displayMin = min;
		if (question.decimals) {
			displayMax = displayMax * Math.pow(10, question.decimals)
			displayMin = displayMin * Math.pow(10, question.decimals)
		}

		return (100 * value) / (displayMax + displayMin);
	}

	const leftValue1 = countLeftPosition(value1);

	const leftStyle1 = {
		left: question.range ? 'calc(50% - 20px)' : 'calc(' + leftValue1 + '% - 22px)',
		top: question.sliderVertical ? "300px" : "0px"
	};

	const getDecimalsValue = (value) => {
		if (question.decimals) {
			value = value / Math.pow(10, question.decimals);
		}

		return value;
	}

	return (
		<React.Fragment>
		{!question.hideSelectedValue && <div className="position-relative mt-4 mb-3">
			<div className={classnames({
				"position-absolute slider-value-info": true,
				"invisible": !detail.value1 && !detail.value2
			})} style={leftStyle1}>
				{question.range
					?
					<div>{!_.isNull(detail.value1) ? getDecimalsValue(detail.value1) : min} {question.valueText} - {!_.isNull(detail.value2) ? getDecimalsValue(detail.value2) : max} {question.valueText}</div>
					:
					<div>{!_.isNull(detail.value1) ? getDecimalsValue(detail.value1) : defaultValue} {question.valueText}</div>
				}
			</div>
		</div>}
		</React.Fragment>
	);
}

SliderSummary.propTypes = {
	question: PropTypes.any.isRequired,
	detail: PropTypes.any.isRequired
};

function mapStateToProps(state) {
	return {}
}

export default connect(mapStateToProps, {})(injectIntl(SliderSummary));